document.querySelectorAll('[data-rewards-carousel]').forEach((carousel) => {
  if (carousel.dataset.rewardsReady === 'true') return;
  carousel.dataset.rewardsReady = 'true';

  const track = carousel.querySelector('[data-rewards-track]');
  const previous = carousel.querySelector('[data-rewards-prev]');
  const next = carousel.querySelector('[data-rewards-next]');
  if (!track || !previous || !next) return;

  const step = () => {
    const card = track.firstElementChild;
    if (!card) return track.clientWidth;
    const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  };
  const update = () => {
    const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= maximum - 2;
  };

  previous.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
});
